import React from "react";
import { Col, Row } from "react-bootstrap";
import { WfControlProps } from "./ControlProps";
import { Input, Radio, RadioGroupProps } from "antd";
import ComponentLabel from "../../../../../../components/ControlComponents/ComponentLabel";

export function WfRadio({
  layout,
  layoutLength,
  fieldState,
  inputProps,
}: Readonly<WfControlProps>) {
  console.log(WfRadio.name, layout);
  return (
    <>
      <ComponentLabel
        colText={2}
        rowIdx={1}
        colIdx={0}
        template={layout.template}
      />
      <Col xs={12} lg={layoutLength === 1 ? 10 : 4}>
        <Radio.Group {...(inputProps as RadioGroupProps)}>
          {layout.template?.attribute?.items?.map((option, i) => (
            <Radio key={i} value={option.item}>
              {option.item}
            </Radio>
          ))}
        </Radio.Group>
        {fieldState.error && (
          <>
            <small className="text-danger">{fieldState.error.message}</small>
          </>
        )}
      </Col>
    </>
  );
}
